// extracted by mini-css-extract-plugin
export default {"container":"dayName_container__CIkdO","arrow":"dayName_arrow__8aeHV","switch":"dayName_switch__ASUfL"};